import Cookies from "js-cookie";
import service from "../Services/apiheader";
import { accessToken } from "./apiFunctions";

const module="xevmpd";

  export const queryIdentifier = (payload: any) =>  service.post(
      `${module}/system/identifiers/query`,
      payload,
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID"),
           Authorization:`Bearer ${accessToken}`
        },
      }
    );
    
    export const saveIdentifier = (payload: any) =>  service.post(
      `${module}/system/binding`,
      payload,
      {
        headers: {
          "x-tenant-id": Cookies.get("USER_TENANT_ID"),
        },
      }
    );
    
export const batchRemoveIdentifier = (payload: any) => {
  return service.post(
    `${module}/system/delete/bulk-binding`,
    payload,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );
}
    
export const batchBindIdentifier = (payload: any) => {

  return service.post(
    `${module}/system/add/bulk-binding`,
    payload,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );
}